'use strict'

module.exports.first = require('./lib/meshcode2latlng').first;
module.exports.second = require('./lib/meshcode2latlng').second;
module.exports.third = require('./lib/meshcode2latlng').third;
module.exports.half = require('./lib/meshcode2latlng').half;
module.exports.quater = require('./lib/meshcode2latlng').quater;
